import * as actionTypes from './actionTypes'
import axios from 'axios'

export const authStart = () => {
    return {
      type: actionTypes.AUTH_START
    }
}

export const authSuccess = (idToken, userId) => {
  return {
      type:actionTypes.AUTH_SUCCESS,
      idToken:idToken,
      userId:userId
  }
}

export const authfail = (error) => {
  return {
    type:actionTypes.AUTH_FAIL,
    error:error
  }
}

export const logout = () => {
  //remove localStorage
  localStorage.removeItem('token');
  localStorage.removeItem('expirationDate');
  localStorage.removeItem('userId')

  return {
    type:actionTypes.AUTH_LOGOUT
  }
}

export const checkAuthTImeout = (expirationTime) => {
  return dispatch => {
      setTimeout(() => {
        dispatch(logout())
      }, expirationTime * 1000);
  }
}

export const auth = (email, password, isSignup) => {
  return dispatch => {
    dispatch(authStart())
    const authData = {
      email:email,
      password:password,
      returnSecureToken:true
    }
    let url = 'https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=AIzaSyB8syECFpz7WPdZUGs7qXBU5mqqZEL6Q-A'
    if(!isSignup) {
      url = 'https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=AIzaSyB8syECFpz7WPdZUGs7qXBU5mqqZEL6Q-A'
    }
    axios.post(url,authData)
    .then(result => {
        
        //expirate date because expiratationDate will not countdown on localStorage
        const expirationDate = new Date(new Date().getTime() + result.data.expiresIn * 1000)

        //set to local storage (must be...men ora ilang pas direfresh)
        localStorage.setItem('token', result.data.idToken)
        localStorage.setItem('expirationDate', expirationDate)
        localStorage.setItem('userId', result.data.localId)

        dispatch(authSuccess(result.data.idToken, result.data.localId))
        dispatch(checkAuthTImeout(result.data.expiresIn))
    })
    .catch(err => {
      dispatch(authfail(err.response.data.error))
    })
  }
}

export const setAuthRedirectPath = (path) => {
  return {
    type:actionTypes.SET_AUTH_REDIRECT_PATH,
    path:path
  }
}

export const authChekState = () => {
  return dispatch => {
    const token = localStorage.getItem('token');
    if(!token) {
      dispatch(logout())
    }else{
      const expirationDate = new Date(localStorage.getItem('expirationDate'));
      if(expirationDate <= new Date()){
        dispatch(logout())
      }else{
        const userId = localStorage.getItem('userId')
        dispatch(authSuccess(token,userId))
        dispatch(checkAuthTImeout((expirationDate.getTime() - new Date().getTime()) / 1000))
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/actions/auth.js